var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBlogPostIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 47,
    viewBox: "0 0 57 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 47h47V0H12.862L6.12 9.52 0 12.062z",
    fill: "#3D82F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H0L13 0z",
    fill: "#C3D8FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46.85c-.418.1-.855.15-1.298.15H47v-7c0 3.373 2.143 6.189 5 6.85",
    fill: "#3D82F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12v27.828A6.304 6.304 0 0 1 52.002 46 6.3 6.3 0 0 1 47 39.828V12z",
    fill: "#C3D8FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21H6v14h14z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 22H26v-1h15zm0 5H26v-2h15zm0 4H26v-1h15zm0 5H26v-2h15z",
    fill: "#050505"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogPostIcon);
export default __webpack_public_path__ + "static/media/BlogPostIcon.07d24db0b1cb705e986736c1364b4162.svg";
export { ForwardRef as ReactComponent };